<div class="container">
  <p class="title">{{ 'symptomAssessment.title_symptoms_step' | translate }}</p>
  <div class="filter-container">
    <ds-search [control]="searchValues.commonInput.control" [placeholder]="'symptomAssessment.search' | translate"></ds-search>
  </div>
  <form [formGroup]="symptomsForm">
    @for (symptom of filteredSymptoms; track symptom) {
      <nz-form-item>
        <nz-form-control>
          <label nz-checkbox [formControlName]="symptom.label">{{ symptom.label }}</label>
        </nz-form-control>
      </nz-form-item>
    }
  </form>
</div>
